import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const MyPlanningTasksDialogTourConfig: AgTechTourConfig = {
    id: 'my-planning-tasks-dialog-tour',
    name: 'My Tasks Tour',
    steps: [
        {
            targetId: 'my-tasks-grid',
            title: 'Your Tasks',
            description: 'Every planning task assigned to you across all sales, with its sale, priority, end date and status. Search by task or sale, and use the row menu to complete or reopen a task or jump to its sale.',
            position: 'top',
        },
    ]
}
